// import { getCookie } from './cookies';

export function initiateOptInNotification() {
  // window._izq.push(['triggerPrompt']);
}

function getDocHeight() {
  const D = document;
  return Math.max(
    D.body.scrollHeight,
    D.documentElement.scrollHeight,
    D.body.offsetHeight,
    D.documentElement.offsetHeight,
    D.body.clientHeight,
    D.documentElement.clientHeight,
  );
}

export function showNotificationPrompt() {
  if (
    typeof window !== 'undefined' &&
    typeof window._izq !== 'undefined' &&
    typeof Notification !== 'undefined' &&
    Notification.permission &&
    Notification.permission !== 'granted' &&
    Notification.permission !== 'blocked' &&
    Notification.permission !== 'denied'
  ) {
    // window._izq.push(['updateSubscription', 'unsubscribe']);
    return true;
  }
  return false;
}

export function pageAmountScrolled(template, msid, currentHref) {
  const winheight =
    window.innerHeight ||
    (document.documentElement || document.body).clientHeight;
  const docheight = getDocHeight();
  const scrollTop =
    window.pageYOffset ||
    (document.documentElement || document.body.parentNode || document.body)
      .scrollTop;
  const trackLength = docheight - winheight;
  const pctScrolled = Math.floor(scrollTop / trackLength * 100); // gets percentage scrolled (ie: 80 or NaN if tracklength == 0)
  if (window.checkScrollForCustomPrompt === undefined) {
    window.checkScrollForCustomPrompt = 0;
  }
  //console.log(`${pctScrolled}% scrolled`, template);
  if (
    pctScrolled >= 20 &&
    pctScrolled > window.checkScrollForCustomPrompt &&
    template &&
    showNotificationPrompt() &&
    (template.toLowerCase() === 'home' ||
      template.toLowerCase() === 'listing' ||
      template.toLowerCase() === 'newslisting')
  ) {
    //initiateOptInNotification();
    return true;
  }
  if (
    pctScrolled >= 60 &&
    pctScrolled > window.checkScrollForCustomPrompt &&
    template &&
    showNotificationPrompt() &&
    (template.toLowerCase() === 'articleshow' ||
      template.toLowerCase() === 'liveblog' ||
      template.toLowerCase() === 'photostory' ||
      template.toLowerCase() === 'movieshow' ||
      template.toLowerCase() === 'moviereview')
  ) {
    //initiateOptInNotification();
    return true;
  }
  if (
    template &&
    pctScrolled > window.checkScrollForCustomPrompt &&
    showNotificationPrompt() &&
    (template.toLowerCase() === 'articleshow' ||
      template.toLowerCase() === 'liveblog' ||
      template.toLowerCase() === 'photostory' ||
      template.toLowerCase() === 'movieshow' ||
      template.toLowerCase() === 'moviereview') &&
    currentHref &&
    currentHref !== window.location.href
  ) {
    return true;
  }
  if (pctScrolled > window.checkScrollForCustomPrompt) {
    window.checkScrollForCustomPrompt = pctScrolled;
  }
  return false;
}

// export function izootoOptIn(template) {
//   window.addEventListener(
//     'scroll',
//     () => {
//       amountscrolled(template);
//     },
//     false,
//   );
//   if (template === 'homepage') {
//     console.log('start timer');
//     setTimeout(() => {
//       console.log('end timer');
//       initiateOptInNotification();
//     }, 5000);
//   }
// }

export function removeScrollListener() {
  window.removeEventListener('scroll', () => {
    pageAmountScrolled();
  });
  delete window.checkScrollForCustomPrompt;
}

export function isNotificationBlocked() {
  //const status = getCookie('notificationStatus');
  if (
    typeof Notification !== 'undefined' &&
    Notification.permission &&
    (Notification.permission === 'blocked' ||
      Notification.permission === 'denied')
  ) {
    return true;
  }
  return false;
}
